// Simple row layout
import React, { useState } from 'react';
import { Input } from '@mui/material';
import {
  type RestModalForwards,
  type RestSixtyFortyColumnActionModal,
} from '@bbkAdminUtils/api-client/rest-modals-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import ActionButtonIcons from '@bbkFunnelComponents/modals/sections/action-button-helpers';
import { FunnelButton } from '@bbkFunnelComponents/v2';

type Props = {
  info: RestModalForwards;
  questions: RestSixtyFortyColumnActionModal['requires']['questions'];
  provides: RestSixtyFortyColumnActionModal['provides'];
  name: string;
  onClick: Function;
};

export const ModalDetailedActions: React.FC<Props> = (props) => {
  const { info, questions, provides, name, onClick } = props;

  // go through questions, make sure each has an answer
  const [state, setState] = useState({
    selectChanged: false,
    ...provides,
  });

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name: fieldName, value } = e.target;
    setState({
      ...state,
      [fieldName]: value,
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name: fieldName, value } = e.target;
    setState({
      ...state,
      [fieldName]: value,
      selectChanged: !!value,
    });
  };

  const generateIntercomMessage = (): string => {
    if (questions.plan_options) {
      return `Current Offer \nPlan: ${state.plan_options} \nBid: $${state.price_per_month}/mo`;
    }
    if (questions.feedback !== undefined) {
      return `${state.feedback}`;
    }
    return '';
  };

  const generateOptions = (options: { name: string; key: string }[]) => {
    return options.map((o) => (
      <option value={o.name} key={o.key}>
        {o.name}
      </option>
    ));
  };

  const validateSubmit = () => {
    if (
      name === 'modal_too_slow' &&
      state.plan_options === '' &&
      state.price_per_month === ''
    ) {
      return false;
    }
    return onClick(info, {
      message: generateIntercomMessage(),
    });
  };

  return (
    <div className="modal-detailed-actions">
      <div className="MDAContainer">
        <div className="detailed-actions">
          {questions.plan_options && (
            <div>
              <div className="da-title">{questions.plan_options.label}</div>
              <div className="select-field">
                <div className="select-wrapper">
                  <select
                    className={cs('select', {
                      'select-changed': state.selectChanged,
                    })}
                    onChange={handleChange}
                    name="plan_options"
                  >
                    <option value="" key="">
                      {questions.plan_options.placeholder || 'Pick Plan'}
                    </option>
                    {generateOptions(questions.plan_options.options)}
                  </select>
                </div>
              </div>
            </div>
          )}
          {questions.price_per_month && (
            <div className="price-per-month">
              <Input
                name="price_per_month"
                disableUnderline
                style={{
                  border: '2px solid #c7c7c7',
                  backgroundColor: '#fbfbfb',
                  borderRadius: '3px',
                  padding: '0px 8px',
                  width: '45px',
                  height: '41px',
                  fontSize: '22px',
                  color: '#5E5E5E',
                  letterSpacing: '-0.11px',
                  lineHeight: '22px',
                  marginRight: '25px',
                }}
                onChange={handleInput}
                placeholder={questions.price_per_month.placeholder || '$45'}
              />
              <span>{questions.price_per_month.period_label || '/mo'}</span>
            </div>
          )}
          {questions.feedback && (
            <Input
              name="feedback"
              multiline
              fullWidth
              disableUnderline
              rows={3}
              style={{
                border: '2px solid #c7c7c7',
                backgroundColor: '#fbfbfb',
                padding: '5px 8px',
                borderRadius: '3px',
                color: '#464646',
                // boxShadow: 'inset 0 0 5px #bfbfbf'
              }}
              onChange={handleInput}
              placeholder="Start typing..."
            />
          )}
        </div>
        <div className="btn">
          <FunnelButton
            onClick={() => validateSubmit()}
            specificStyles={{ width: '100%' }}
            classes="d-flex align-items-center justify-content-center"
          >
            {info.icon && <ActionButtonIcons icon={info.icon} />}
            <span>{info.text}</span>
          </FunnelButton>
        </div>
      </div>
    </div>
  );
};
